import script from "./IntervalsTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./IntervalsTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./IntervalsTableLoader.vue?vue&type=style&index=0&id=c8e0ee80&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8e0ee80"]])

export default __exports__